<template>
  <div class="container">
    <!-- 修正logo部分 -->
    <header>
      <a class="logo" href="http://www.sanxinbook.com">
      <!-- <a class="logo" href="http://192.168.7.96:8082/#/Xindex"> -->

        <div style="display:flex;">
          <img src="../../assets/images/shuxiang.png" alt="三新文化">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <div>三 新 文 化</div>
          <div class="logo-text">SUNSHINE CULTURE</div>
        </div>
        </div>
      </a>
    </header>

    <!-- 调整倒计时结构 -->
    <div class="content">
      <p class="text">3月16日即将上线，敬请期待......</p>
      <div class="countdown-wrapper">
        <p class="sub-text">距上线还有：</p>
        <div class="timedown">
          <div class="time-block " style="background-color:#9acd32 ;">
            <div class="number">{{ days }}</div>
            <div class="unit">天</div>
          </div>
          <div class="time-block" style="background-color:#ffa500 ;">
            <div class="number">{{ hours }}</div>
            <div class="unit">时</div>
          </div>
          <div class="time-block" style="background-color:#db7093;">
            <div class="number">{{ minutes }}</div>
            <div class="unit">分</div>
          </div>
          <div class="time-block" style="background-color:#00a0e9 ;">
            <div class="number">{{ seconds }}</div>
            <div class="unit">秒</div>
          </div>
        </div>
      </div>
      <!-- 修正按钮样式 -->
      <div  @click="goyuntiangou" 
         class="demo-btn"
         >
        云田购入口
      </div>
    </div>

    <!-- 修正底部信息 -->
    <footer class="footer">
      <div class="contact-info">
        <p>客服热线：027-51850968  地址：武汉市东湖新技术开发区佛祖岭街道金培路2号</p>
        <p> 湖北三新文化传媒有限公司 版权所有 鄂ICP备13015831号-1<br>
          Copyright 1998-2025 www.sanxinbook.com All Rights Reserved.</p>
      </div>
      <!-- <div class="copyright">
       
      </div> -->
    </footer>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import Axios from "@/api/diyaxios";
export default {
  
  data() {
    return {
      targetDate: new Date('2026-03-16T07:50:00'), // 使用 ISO 8601 格式表示时间
      now: Date.now(),
      timer: null,
      checkInterval: null,  // 新增检测定时器
      isChecking: false     // 防止重复请求
    }
  },
  computed: {
    diffTime() {
      return Math.max(this.targetDate - this.now, 0)
    },
    days() {
      return Math.floor(this.diffTime / (1000 * 3600 * 24)).toString().padStart(2, '0')
    },
    hours() {
      return Math.floor((this.diffTime % (1000 * 3600 * 24)) / (1000 * 3600)).toString().padStart(2, '0')
    },
    minutes() {
      return Math.floor((this.diffTime % (1000 * 3600)) / (1000 * 60)).toString().padStart(2, '0')
    },
    seconds() {
      return Math.floor((this.diffTime % (1000 * 60)) / 1000).toString().padStart(2, '0')
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = Date.now()
      if (this.diffTime <= 0) clearInterval(this.timer)
    }, 1000)
     // 新增状态检测逻辑
     this.startStatusCheck()
  },
  methods:{
    // 新增状态检测方法
    async checkStatus() {
      if (this.isChecking) return
        this.isChecking = true
        Axios.post(
        "/rmd/rmdsetting/gettiaozhuan",{},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          this.isChecking =false;
          console.log(res);
          this.handleStatus(res.data)
        })
        .catch((err) => {
          this.isChecking = false;
        });
    },

    // 处理状态响应
    handleStatus(status) {
      console.log(status,'status');
      
      if(JSON.parse(localStorage.getItem('user'))){
        const user = JSON.parse(localStorage.getItem('user'));
        // 已登录
        user.source=status;
        localStorage.setItem("user",JSON.stringify(user));
      }
      switch(status) {
        // case "0":
        case "0":
          if (this.checkInterval) {
            clearInterval(this.checkInterval)
            this.checkInterval = null
          }
          Cookies.set('logintype',0)
          this.$router.push({ name: "HomePage" })
          break
        case "1":
          if (this.checkInterval) {
            clearInterval(this.checkInterval)
            this.checkInterval = null
          }
          Cookies.set('logintype',1)
          this.$router.push({ name: "Xindex", query: { key:1 } })
        
          break
        case "2":
          // 保持当前页面，继续轮询
          // Cookies.set('logintype',0)   // 需要注释发版
          // this.$router.push({ name: "HomePage" })    // 需要注释发版
          break
        default:
          console.warn('未知状态码:', status)
      }
    },

    // 启动定时检测
    startStatusCheck() {
      // 立即执行第一次检测
      this.checkStatus()
      // 设置定时器（3分钟）
      this.checkInterval = setInterval(() => {
        this.checkStatus()
      }, 180000) // 180000毫秒 = 3分钟
    },
    goyuntiangou(){
      Cookies.set('logintype',1)
      this.$router.push({ name: "Xindex",query:{ key:1 }  },)
    },
  },
  beforeUnmount() {
    clearInterval(this.timer)
     // 清理状态检测定时器
     if (this.checkInterval) {
      clearInterval(this.checkInterval)
      this.checkInterval = null
    }
  }
}
</script>

<style scoped>
  /* 新增容器样式 */
.container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
/* 头部固定 */
header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  /* 保留原有样式 */
  height: 80px;
  padding: 15px 30px;
  display: flex;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  gap: 15px;
  text-decoration: none;
}

.logo img {
  height: 50px;
  width: auto;
}

.logo div:first-child {
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.logo-text {
  font-size: 16px;
  color: #666;
  letter-spacing: 1px;
  margin-top: 3px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .logo img {
    height: 40px;
  }
  .logo div:first-child {
    font-size: 20px;
  }
  .logo-text {
    font-size: 14px;
  }
}

.content {
  text-align: center;
  background-color: #f8f8f8;
  flex: 1;
  padding: 8% 0 8%;  /* 调整底部留白 */
}
.timedown .red{background: #ff0000}
.timedown .yg{background: yellowgreen}
.timedown .or{background: orange}
.timedown .pi{background: palevioletred}
.timedown .pk{background: #00a0e9}
.timedown .mk{background: #1FADC5}
.timedown  p:first-child{font-size: 36px}
.timedown  p:last-child{font-size: 24px}
.text {
  font-size: 28px;
  color: #666;
  margin-bottom: 30px;
}

.sub-text {
  font-size: 20px;
  color: #999;
  margin-bottom: 20px;
}

.timedown {
  display: flex;
  justify-content: center;
  gap: 25px;
  margin-bottom: 40px;
  color: #fff;
}

.time-block {
  width: 80px;
  height: 80px;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 15px 20px;
}

.number {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 5px;
}

.unit {
  font-size: 24px;
}

.demo-btn {
  display: inline-block;
  background: #1890ff;
  color: white;
  padding: 12px 45px;
  border-radius: 5px;
  font-size: 18px;
  text-decoration: none;
  box-shadow: 0 4px 6px rgba(24,144,255,0.2);
  cursor: pointer;
}

.footer {
  background: #dddddd;
  padding: 10px 0;
  position: sticky;
  bottom: 0;
  z-index: 50;
  margin-top: auto;  /* 确保始终在底部 */
}

.contact-info {
  font-size: 14px;
  width: 80%;
  margin: 0 auto 20px;
}
.contact-info p {
  margin: 10px 0;
  display: flex;
  align-items: center;
  line-height: 1.6;
  text-align: center;
  justify-content: center;
  gap: 10px;
  color: #666;
}

.copyright {
  text-align: center;
  color: #999;
  font-size: 14px;
  line-height: 1.8;
}
</style>


// WEBPACK FOOTER //
// src/views/preheatingcountdown/preheatingcountdown.vue